const zh = {
  rule: '规则说明',
  Referral: '转介',
  Total_Earnings: '收入总数',
  Top_Referrer: '顶级推荐者',
  share: '分享',
  Starter_Referrer: '起步推荐者',
  refer_desc:
    '在新用户下单付款后，系统会分别奖励有效邀请奖励至推荐人。奖励如下：',
  points: '积分',
  cash_voucher: '代金券',
  international: '国际',
  next_day_delivery: '次日达',
  n_user: '第{num1}人',
  your_referral_code: '您的推荐码',
  already_top_referral:
    '您已经成为"顶级推荐人" 每邀请一位新用户，您将获得上述奖励',
  already_top_referral_text: '每邀请一位新用户，您将获得上述奖励',
  zai_add_new_user_n: '邀请{num1}位新用户升级为"顶级推荐人" ',
  open_lock_five_new_user: '解锁第5位新用户',
  Invitation_record: '邀请记录',

  // 注册页面
  register_title: '注册',
  phone: '手机号',
  phone_placeholder: '请输入手机号',
  phone_required: '手机号不能为空',
  phone_length: '手机号长度不能超过13位',
  password: '登录密码',
  password_placeholder: '请输入登录密码',
  password_required: '登录密码不能为空',
  verification_code: '验证码',
  verification_code_placeholder: '请输入验证码',
  verification_code_required: '验证码不能为空',
  verification_code_format: '验证码必须为数字，最多6位',
  send_code: '获取验证码',
  resend_code: '重新发送',
  privacy_agreement: '我已阅读并同意隐私协议',
  please_check_privacy: '请勾选隐私协议',
  download_app: '下载J&T Malaysia应用',
  name: '姓名',
  name_placeholder: '请输入姓名',
  name_length: '姓名长度不能超过50',
  name_invalid_char: '姓名包含非法字符',
  id_number: '身份证号/护照号/SSM',
  id_number_placeholder: '请输入身份证号/护照号/SSM',
  id_number_required: '身份证号/护照号/SSM不能为空',
  id_number_format: '必须为数字，最多12位',
  email: '邮箱',
  email_placeholder: '请输入邮箱',
  email_required: '邮箱不能为空',
  email_format: '邮箱格式不正确',
  referral_code: '推荐码',
  referral_code_placeholder: '推荐码',
  postcode: '邮编',
  postcode_placeholder: '请输入邮编',
  postcode_format: '邮编必须为5位数字',
  postcode_not_found: '此邮编不存在',
  city: '城市',
  city_placeholder: '请输入邮编自动带出城市',
  city_required: '城市不能为空，请输入有效邮编',
  address: '地址',
  address_placeholder: '请输入地址',
  address_length: '地址长度不能超过250',
  address_invalid_char: '地址包含非法字符',
  complete_register: '完成注册',
  register_success: '注册成功',
  register_success_desc: '恭喜您注册成功！',
  back_to_home: '返回首页',
  account_info: '账号信息',
  identity_info: '身份信息',
  contact_address: '联系地址',
  privacy_prefix: '我已阅读并同意 J&T Express',
  privacy_terms: '《条款和隐私政策》',
  already_have_account: '已有账户？',
  download_jt_malaysia_app: '立即登录',
  area_placeholder: '请选择/输入城市',
  verification_code_error: '验证码错误',
  register_success_title: '恭喜您，注册成功!',
  register_success_detail:
    '您的账号已激活，现在下载App，解锁更多<br />物流服务&专属奖励',
  download_jt_malaysia_app_now: '立即登录',
  register_download_desc:
    '下载App后，登录已注册的手机号，即可使用所有服务<br />并领取奖励',
  register_footer_text: 'J&T Malaysia · 为你提供便捷的物流服务'
}

export default zh
